import { MIN_HEIGHT } from './consts';
import { nodeContainerStyles } from './style';

export const calMaxWidth = () => {
  return document.getElementsByClassName('editor-container').length
    ? document.getElementsByClassName('editor-container')[0].clientWidth
    : window.innerWidth;
};

export const setTextareaHeight = (captionInputRefCurrent: HTMLTextAreaElement | null) => {
  if (captionInputRefCurrent) {
    captionInputRefCurrent.style.height = '1px';
    captionInputRefCurrent.style.height = captionInputRefCurrent.scrollHeight + 'px';
  }
};

type ApplyStylesFn = (
  event: MouseEvent,
  options: {
    eventPosition: Record<'x' | 'y', number>;
    nodeRefCurrent: HTMLDivElement;
    nodeContainer: HTMLDivElement;
    resize: Record<'left' | 'right' | 'top' | 'bottom', boolean>;
    minDimension: number;
  },
) => void;

export const applyHorizontalStyles: ApplyStylesFn = (
  e,
  { eventPosition, nodeRefCurrent, nodeContainer, resize, minDimension },
) => {
  const startWidth = nodeRefCurrent.style.width
    ? parseFloat(nodeRefCurrent.style.width)
    : nodeRefCurrent.getBoundingClientRect().width;
  const currentX = e.pageX;
  const diffInPx = resize.right ? currentX - eventPosition.x : eventPosition.x - currentX;
  // Divide the difference of the cursor position by 10 to have a smooth
  // experience of the resizing.
  const calculatedWidth = Math.min(minDimension, Math.max(startWidth + diffInPx / 20, 200));
  nodeRefCurrent.style.width = calculatedWidth + 'px';

  // There is extra padding of 16px in the ProseMirror class.
  const newStyle = nodeContainerStyles(calculatedWidth);
  nodeContainer.style.width = newStyle.width;
  nodeContainer.style.marginLeft = newStyle.marginLeft;
  nodeContainer.style.marginRight = newStyle.marginRight;
};

export const applyVerticalStyles: ApplyStylesFn = (
  e,
  { eventPosition, nodeRefCurrent, nodeContainer, resize, minDimension },
) => {
  const startHeight = nodeRefCurrent.style.height
    ? parseFloat(nodeRefCurrent.style.height)
    : nodeRefCurrent.getBoundingClientRect().height;

  const currentY = e.pageY;
  const diffInPx = resize.bottom ? currentY - eventPosition.y : eventPosition.y - currentY;

  const calculatedHeight = Math.min(
    minDimension,
    Math.max(startHeight + diffInPx / 20, MIN_HEIGHT),
  );
  nodeRefCurrent.style.height = calculatedHeight + 'px';
};
